<template>
  <div class="sm-customers">
    <div class="sm-wrap lg">
      <customers-top 
        @action="handleAction"
        @upload="handleImportCustomers"
      />
      <customers-main 
        :key="listKey"
        @action="handleAction"
      />
    </div>

    <popup-block
      v-if="popup.isOpen"
      :open="popup.isOpen"
      :size="'default'"
      @close="popup.isOpen = false;"
    >
      <template slot="popupContent">
        <div
          v-if="popup.type == 'transfer'"
          class="sm-customers__transfer"
        >
          <h4>Account transfer successful</h4>
          <a
            v-if="transferDestination"
            :href="`${transferDestination}customers`"
            target="_blank"
          >New Account Destination</a>
          <btn-block
            :text="'Close'"
            @click="popup.isOpen = false"
          />
        </div>
        <div
          v-else-if="popup.type == 'import'"
          class="sm-customers__import"
        >
          <h4>Import complete</h4>
          <p>Total imported accounts: <span class="sm-txt-strong">{{importResults.total_imported_accounts}}</span></p>
          <template v-if="importResults.errors.length">
            <h5>Errors:</h5>
            <ul>
              <li
                v-for="(error, index) in importResults.errors"
                :key="index"
              >{{error}}</li>
            </ul>
          </template>
        </div>
        <div
          v-else-if="popup.type == 'import-error'"
          class="sm-customers__import"
        >
          <h4>Can't parse .csv file</h4>
          <p>{{importError}}</p>
          <btn-block
            :type="'small'"
            :text="'Close'"
            @click="popup.isOpen = false"
          />
        </div>
        <form-customer-lvl1
          v-else-if="popup.type == 'add-lvl1'"
          :backErrors="formErrors"
          @cancel="popup.isOpen = true"
          @submit="handleSubmitLvl1"
        />
      </template>
    </popup-block>

    <sm-spinner :show="showSpinner" />

    <a
      href="#"
      :ref="'link'"
      class="sm-customers__download"
    >Link</a>
  </div>
</template>

<script>
import Top from '@/views/admin/pages/customers/Top';
import Main from '@/views/admin/pages/customers/Main';
import Popup from '@/components/Popup';
import Spinner from '@/components/Spinner';
import FormCustomerLvl1 from '@/components/forms/FormCustomerLvl1';
import { mapActions, mapGetters } from 'vuex';
import {IsRightFileType} from '@/utils/general-data';

export default {
  name: 'customers',
  components: {
    'customers-top': Top,
    'customers-main': Main,
    'popup-block': Popup,
    'sm-spinner': Spinner,
    'form-customer-lvl1': FormCustomerLvl1
  },
  data() {
    return {
      popup: {
        isOpen: false,
        type: null, // values: export, transfer, import, import-error, add-lvl1
      },
      formErrors: [],
      showSpinner: false,
      transferDestination: '',
      listKey: 0,
      importResults: {
        total_imported_accounts: 0,
        errors: []
      },
      importError: '',
      exportUrl: '',
    }
  },
  computed: {
    ...mapGetters({
      provider: 'provider'
    })
  },
  created() {
    let query = Object.assign({}, this.$route.query);

    if (query.transfer_to) {
      this.transferDestination = query.transfer_to;
      this.popup.type = 'transfer';
      this.popup.isOpen = true;

      delete query.transfer_to;
      this.$router.replace({query});
    }
  },
  methods: {
    ...mapActions({
      exportCustomers: 'customers/exportCustomers',
      importCustomers: 'customers/importCustomers',
      createCustomerLvl1: 'customers/createCustomerLvl1'
    }),
    isRightFileType: IsRightFileType,
    handleAction(name, val) {
      switch(name) {
        case 'setExportUrl':
          this.exportUrl = val;
          break;
        case 'export':
          this.handleExportCustomers();
          break;
        case 'new':
          if (this.provider.client_level != 1)
            this.$router.push('add-customer');
          else
            this.addCustomerLvl1();
          break;
        default:
          this.popup = {
            isOpen: true,
            type: name
          }
          break;
      }
    },
    handleExportCustomers() {
      let link = this.$refs.link;
      link.setAttribute("href", this.exportUrl);
      link.setAttribute("download", "result.csv");
      link.click();   
    },
    handleImportCustomers(file) {      
      if (!file)
        return;
        
      this.showSpinner = true;
      let formData = new FormData();

      formData.append('file', file);
      
      this.importCustomers(formData)
        .then(res => {
          this.importResults = res;
          this.popup = {
            type: 'import',
            isOpen: true
          };

          if (res.total_imported_accounts)
            this.listKey++;

          this.showSpinner = false;
        })
        .catch(e => {
          let err = e.response;

          if (err && err.data && err.data.errors && err.data.errors.base) {
            this.importError = err.data.errors.base[0];
            this.popup.type = 'import-error';
            this.popup.isOpen = true;
          }

          this.showSpinner = false;
        });
    },
    addCustomerLvl1() {
      this.popup.type = 'add-lvl1';
      this.popup.isOpen = true;
    },
    handleSubmitLvl1(data) {
      this.showSpinner = true;

      this.createCustomerLvl1(data)
        .then(res => {
          this.$router.push({query: {tab: 'update'}});
          setTimeout(() => {
            this.$router.push({query: {tab: 'inactive'}});
            this.popup.isOpen = false;
            this.showSpinner = false;
          }, 100);
        })
        .catch(e => {
          console.log('error on create user', e, e.response);
          let err = e.response

          if (err && err.data && err.data.errors) {
            Object.keys(err.data.errors).forEach(key => {
              this.formErrors.push({
                field: key,
                msg: err.data.errors[key][0]
              });
            });
          }

          this.showSpinner = false;
        })
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/general/mixins.scss';
  @import '@/assets/scss/framework/scss-variables.scss';
  @import '@/assets/scss/pages/common/customers/_customers.scss';
</style>
